var exports = {
  "N": "Text_0__LKqVBJ",
};

module.exports = exports;
